// eslint-disable-file react-hooks/exhaustive-deps //
import React, { FC, useEffect, useState, SyntheticEvent, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import {
    Button,
    Dialog,
    DialogTitle,
    Divider,
    makeStyles,
    DialogContent,
    DialogActions,
    Grid,
    Typography,
    Snackbar,
    TextField,
    Select,
    MenuItem,
    Tab,
    Box,
    TableHead,
    Tooltip,
    IconButton,
    Tabs,
} from '@material-ui/core'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import Alert, { Color } from '@material-ui/lab/Alert'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import { useDispatch, useSelector } from 'react-redux'
import { promiseError } from '../../../shared/redux/actions/common'
import { changeConfigurationChargers, fetchConfigurationChargers } from '../../../redux/actions/chargerConfiguration'
import {
    resetCharger,
    changeConnectorAvailability,
    uploadChargerCsv,
    unlockConnector,
    startCharging,
    stopCharging,
    resetStartChargingState,
    resetStoptChargingState,
    resetChargerConfigurationState,
} from '../../../redux/actions/locations'
import {
    Charger,
    ChargerConnector,
    ChargerConnectorAvailability,
    ChargerConnectorState,
    ConfigItem,
    getLabelForChargerConnectorSocketType,
    getLabelForChargerConnectorType,
} from '../../../shared/types/charger'
import { ConfirmationDialog } from '../../../shared/components/confirmationDialog'
import { updateConnectorAvailability } from '../../../redux/actions/locations'
import moment from 'moment'
import StartTransactionDialog from '../startTransactionDialog/StartTransactionDialog'
import { TabPanel } from '../../../shared/components/tabPanel'
import { InfoOutlined } from '@material-ui/icons'
import DeleteIcon from '@material-ui/icons/Delete';
import { ChargingSession, ChargingSessionState } from '../../../shared/types/chargingSession'

const useStyles = makeStyles((theme) => ({
    dialog: {
        '& .MuiFilledInput-root': {
            borderRadius: theme.spacing(0.5),
        },
        '& .MuiFilledInput-root::before': {
            border: 0,
        },
        '& .MuiGrid-container': {
            padding: theme.spacing(2, 1),
        },
        '& .MuiGrid-item': {
            display: 'flex',
        },
        '& .MuiTableCell-sizeSmall': {
            padding: theme.spacing(0.5, 1),
        },
        '& .MuiTableRow-root:last-child .MuiTableCell-sizeSmall': {
            borderBottom: 0,
        },
        '& .MuiTabs-indicator': {
            backgroundColor: theme.palette.primary.main,
        },
        '& .MuiTab-root': {
            minWidth: '135px',
        },
        '& .MuiDialog-paper': {
            maxWidth: '781px !important',
        },
        '& .MuiFormControl-root': {
            width: '100%',
        },
        '& .MuiButton-containedSecondary:hover': {
            color: '#ffffff',
        },
    },
    dialogActions: {
        padding: theme.spacing(1, 3, 3, 3),
    },
    dividerMarginBottom: {
        marginBottom: theme.spacing(2),
    },
    fullWidth: {
        width: '100%',
    },
    divider: {
        minWidth: '400px',
    },
    uploadInput: {
        display: 'none',
    },
    textOk: {
        color: theme.palette.success.main,
        borderColor: theme.palette.success.main,
    },
    textNok: {
        color: theme.palette.error.main,
        borderColor: theme.palette.error.main,
    },
    spacedButtons: {
        '& button, label': {
            display: 'inline-block',
            margin: theme.spacing(1),
        },
    },
    centerButtons: {
        justifyContent: 'center',
    },
    connectorId: {
        minWidth: '55px',
        display: 'inline-block',
    },
    connectorType: {
        minWidth: '95px',
        display: 'inline-block',
    },
    connectorButtons: {
        minWidth: '175px',
        display: 'inline-block',
    },
    // input: {
    //     margin: '5px',
    // },
    connectorStatus: {
        display: 'inline-block',
        borderRadius: '50%',
        height: '10px',
        width: '10px',
        position: 'relative',
    },
    dotRed: {
        backgroundColor: 'red',
        marginRight: '5px',
    },
    dotGreen: {
        backgroundColor: 'green',
        marginRight: '5px',
    },
    dotYellow: {
        backgroundColor: 'yellow',
        marginRight: '5px',
    },
    input: {
        backgroundColor: '#f5f5f5',
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden',
        border: '1px solid #ddd',

        '& .MuiFilledInput-root': {
            backgroundColor: '#f5f5f5',
            borderRadius: theme.shape.borderRadius,
            height: '24px',
            boxShadow: 'none',
            paddingLeft: '5px',
        },
        '& .MuiFilledInput-input': {
            padding: '0px'
        },
    },
    inputSelect: {
        backgroundColor: '#f5f5f5',
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden',
        border: '1px solid #ddd',
        height: '28px',
        width: 'calc(100% + 2px)',

        '& .MuiSelect-root': {
            backgroundColor: '#f5f5f5',
            borderRadius: theme.shape.borderRadius,
            boxShadow: 'none',
            padding: '4px',
        },
        '& .MuiSelect-nativeInput': {
            padding: '0px'
        },
    },
    customConfigsContainer: {
        marginTop: '0px',
        width: '100%',
    },
    customConfigRow: {
        padding: '0px 8px !important',
    },
    errorMessage: {
        textAlign: 'center',
        width: '100%',
        marginTop: theme.spacing(2),
    },
    customKey: {
        width: '43%',
    },
    customValue: {
        width: '41.5% !important',
    }
}))

interface ChargerSettingsDialogProps {
    open: boolean
    onClose(): void
    initialModel: Charger
}
interface IAlertMessage {
    message: string | undefined
    autohide: boolean
    severity: Color | undefined
}
const defaultAlert: IAlertMessage = {
    message: undefined,
    autohide: false,
    severity: undefined,
}

const ChargerSettingsDialog: FC<ChargerSettingsDialogProps> = ({ open, onClose, initialModel }) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const classes = useStyles()

    const locationDetail = useSelector((state: any) => state.locations.detail.value)
    const chargerConnectors =
        locationDetail?.chargers && initialModel
            ? locationDetail.chargers.find((charger: Charger) => charger.id === initialModel.id)?.connectors
            : []

    const charger =
        locationDetail?.chargers && initialModel
            ? locationDetail.chargers.find((charger: Charger) => charger.id === initialModel.id)
            : ''

    const externalId = charger.externalId
    const [chargerAuthorization, setChargerAuthorization] = useState(charger.authorizationRfid || '')
    const resetChargerState = useSelector((state: any) => state.locations.chargers.resetCharger)
    const connectorAvailabilityState = useSelector((state: any) => state.locations.chargers.changeConnectorAvailability)
    const unlockConnectorState = useSelector((state: any) => state.locations.chargers.unlockConnector)
    const uploadChargerCsvState = useSelector((state: any) => state.locations.chargers.uploadChargerCsv)
    const stopChargingState = useSelector((state: any) => state.locations.chargers.stopCharging)
    const startChargingState = useSelector((state: any) => state.locations.chargers.startCharging)
    const changeConfiguration = useSelector((state: any) => state.locations.chargers.chargerConfiguration.update)
    const [configUpdateResponse, setConfigUpdateResponse] = useState<Record<string, string | null>>({});
    const [configUpdateRequest, setConfigUpdateRequest] = useState<string[]>([]);

    const [chargerConfigurationFiltered, setChargerConfigurationFiltered] = useState<ConfigItem[]>([]);
    const [chargerChangeConfiguration, setChargerChangeConfiguration] = useState<ConfigItem[]>([]);
    const [customConfigs, setCustomConfigs] = useState<ConfigItem[]>([]);

    const chargerConfiguration = useSelector((state: any) => state.locations.chargers.chargerConfiguration.items)
    const [configurationLoaded, setConfigurationLoaded] = useState<boolean>(false)
    const [configurationLoadSuccess, setConfigurationLoadSuccess] = useState<boolean>(false)

    const [confirmDialogOpen, setConfirmDialogOpen] = useState({ avail: false, reset: false, unlock: false })
    const [confirmDialogProps, setConfirmDialogProps] = useState<any>()
    const [apiResponseMessage, setApiResponseMessage] = useState(defaultAlert)
    const [transactionDetailsDialogOpen, setTransactionDetailsDialogOpen] = useState(false)

    const ocppCommunicationSuccess = 0
    const ocppCommunicationFailed = 1
    const ocppCommunicationScheduled = 2
    const ocppCommunicationDeviceNotConnected = 3
    const ocppCommunicationFailedForcedSuccess = 4

    const [tabIndex, setTabIndex] = useState<number>(0)

    const createAlertMessage = useCallback((msgCode: number): void => {
        let msgCodes: any = []

        msgCodes[ocppCommunicationSuccess] = {
            message: t('locations.operationCompleted'),
            severity: 'success',
        }
        msgCodes[ocppCommunicationFailed] = {
            message: t('locations.operationFailed'),
            severity: 'error',
        }
        msgCodes[ocppCommunicationScheduled] = {
            message: t('locations.operationScheduled'),
            severity: 'warning',
        }
        msgCodes[ocppCommunicationDeviceNotConnected] = {
            message: t('locations.deviceNotConnected'),
            severity: 'error',
        }
        msgCodes[ocppCommunicationFailedForcedSuccess] = {
            message: t('locations.chargerSocketNotConnectedButAvailabilityChangedToInoperative'),
            severity: 'success',
        }

        setApiResponseMessage({
            message: msgCodes[msgCode].message,
            autohide: false,
            severity: msgCodes[msgCode].severity,
        })
    }, [t, setApiResponseMessage]);

    const openStartTransactionDialog = () => {
        setTransactionDetailsDialogOpen(true)
    }

    const handleStartTransactionDialogClose = (details: {
        userId: string
        pricingConditionId: string
        connectorId: string
    }) => {
        setTransactionDetailsDialogOpen(false)
        if (details.userId) {
            const session = {
                chargingConnectorId: details.connectorId,
                userId: details.userId,
                pricingConditionId: details.pricingConditionId,
            }
            handleStartTransaction(session)
        }
    }

    const handleChargerReset = (resetType: number) => {
        setApiResponseMessage(defaultAlert)
        setConfirmDialogProps({ resetType })
        setConfirmDialogOpen({ ...confirmDialogOpen, reset: true })
    }

    const handleConnectorAvailability = (connectorId: string, availType: number) => {
        setApiResponseMessage(defaultAlert)
        setConfirmDialogProps({ connectorId, availType })
        setConfirmDialogOpen({ ...confirmDialogOpen, avail: true })
    }

    const handleConnectorUnlock = (connectorId: string) => {
        setApiResponseMessage(defaultAlert)
        setConfirmDialogProps({ connectorId })
        setConfirmDialogOpen({ ...confirmDialogOpen, unlock: true })
    }

    const handleGetConfiguration = (externalId: string) => {
        setConfigurationLoaded(true);
        setConfigurationLoadSuccess(false); // clear old success state
        setCustomConfigs([]);               // clear custom inputs
        setConfigUpdateRequest([]);         // clear submitted keys
        setConfigUpdateResponse({});        // clear tooltip statuses
        setChargerChangeConfiguration([]);  // optional: reset user edits on default configs

        dispatch(fetchConfigurationChargers(externalId));
    };

    const handleSetConfiguration = () => {
        if (chargerChangeConfiguration.length > 0 || customConfigs.length > 0) {
            const validCustomConfigs = customConfigs.filter(cfg => cfg.key.trim() && cfg.value.trim());
            const fullConfig: ConfigItem[] = [...chargerChangeConfiguration, ...validCustomConfigs];

            const orderedKeys = fullConfig.map(cfg => cfg.key);
            setConfigUpdateRequest(orderedKeys);

            dispatch(changeConfigurationChargers(charger.id, fullConfig));
        }
    };

    const handleChangeConfigurationValue = (key: string) => (e: React.ChangeEvent<any>) => {
        const newValue = e.target.value;

        setChargerChangeConfiguration(prev =>
            [
                ...prev.filter(item => item.key !== key), // remove existing if exists
                { key, value: newValue }
            ]
        );
    };

    const handleAddCustomConfig = () => {
        setCustomConfigs(prev => [...prev, { key: '', value: '' }]);
    };

    const handleRemoveCustomConfig = (index: number) => {
        setCustomConfigs(prev => prev.filter((_, i) => i !== index));
    };

    const handleCustomConfigChange = (index: number, field: 'key' | 'value', newValue: string) => {
        setCustomConfigs(prev => {
            const updated = [...prev];
            updated[index][field] = newValue;
            return updated;
        });
    };

    const detectValueType = (value: string | null | undefined): 'boolean' | 'number' | 'text' => {
        if (value === null) return 'text'; // handles null and undefined
        if (value === 'true' || value === 'false') return 'boolean';
        if (!isNaN(Number(value)) && value?.trim() !== '') return 'number';
        return 'text';
    };

    const isDuplicateKey = (key: string, index: number): boolean => {
        if (!key.trim()) return false;

        const existsInOriginal = chargerConfigurationFiltered.some(cfg => cfg.key === key);
        const existsInOtherCustom = customConfigs.some((cfg, i) => cfg.key === key && i !== index);

        return existsInOriginal || existsInOtherCustom;
    };

    const renderConfigurationValueInput = (entry: any) => {
        const currentValue =
            chargerChangeConfiguration.find(item => item.key === entry.key)?.value ?? entry.value;

        const valueType = detectValueType(currentValue);

        const commonProps = {
            fullWidth: true,
            variant: 'filled' as const,
        };

        if (valueType === 'boolean') {
            return (
                <Select
                    className={classes.inputSelect}
                    value={currentValue}
                    onChange={handleChangeConfigurationValue(entry.key)}
                    {...commonProps}
                >
                    <MenuItem value="true">True</MenuItem>
                    <MenuItem value="false">False</MenuItem>
                </Select>
            );
        }

        return (
            <TextField
                className={classes.input}
                type="text"
                value={currentValue}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const newValue = e.target.value;

                    // Allow only digits and optionally one decimal point
                    if (valueType !== 'number' || /^\d*\.?\d*$/.test(newValue)) {
                        handleChangeConfigurationValue(entry.key)(e);
                    }
                }}
                inputProps={{
                    inputMode: valueType === 'number' ? 'decimal' : 'text',
                    pattern: valueType === 'number' ? '[0-9]*' : undefined,
                }}
                {...commonProps}
            />
        );
    }

    const handleFileUpload = async (ev: any) => {
        ev.persist()
        if (ev.target.files[0]) {
            const fileExt = ev.target.files[0].name.split('.').pop().toString().toLowerCase()
            const allowedExt = ['csv', 'txt']
            if (allowedExt.indexOf(fileExt) > -1) {
                const uploadType = ev.target.id === 'inputUploadNew' ? 1 : 0
                await dispatch(uploadChargerCsv(initialModel.id, uploadType, ev.target.files[0]))
                ev.target.value = ''
            } else {
                dispatch(promiseError(t('locations.uploadedFileNotSupported')))
            }
        }
    }

    const handleStartTransaction = async (session: any) => {
        if (session) {
            let connectorId = session.chargingConnectorId
            if (connectorId === null) {
                connectorId = getPreparedConnector().id
            }
            await dispatch(startCharging(session.userId, connectorId, session.pricingConditionId))
        }
    }

    const handleStopTransaction = async (sessionId?: string) => {
        if (sessionId) {
            const result = await dispatch(stopCharging(sessionId))
            if (result != null) {
                console.log(result)
            }
        }
    }

    const connectorToString = (connector: ChargerConnector) => {
        const type = getLabelForChargerConnectorType(connector.type, t)
        const socketType = getLabelForChargerConnectorSocketType(connector.socketType, t)
        return `${socketType} ${type}`
    }

    const getCurrentSessionForConnector = (connector: ChargerConnector) => {
        if (locationDetail.currentSessions.length) {
            return locationDetail.currentSessions.find(
                (session: ChargingSession) => session.chargingConnector.id === connector.id
            )
        }
    }

    const getAuthorizedSessionInfo = (rfid: string) => {
        if (locationDetail.currentSessions.length) {
            return locationDetail.currentSessions.find((session: ChargingSession) => session.idTag === rfid)
        }
    }

    const getPreparedConnector = () => {
        if (charger?.connectors) {
            const connector = charger.connectors.find(
                (connector: ChargerConnector) =>
                    connector.ocppStatus === 'Preparing'
            )
            return connector || null
        }
        return null
    }

    const getConnectorStatusClass = (connector: ChargerConnector) => {
        if (connector.availability === ChargerConnectorAvailability.Available && connector.state === ChargerConnectorState.Free) {
            return classes.dotGreen;
        } else if (connector.availability === ChargerConnectorAvailability.Available && connector.state !== ChargerConnectorState.Free) {
            return classes.dotYellow;
        } else {
            return classes.dotRed;
        }
    };

    useEffect(() => {
        if (chargerConfiguration?.value?.length) {
            const filtered = chargerConfiguration.value.filter(
                (item: ConfigItem) => !item.key.match(/\//)
            );
            setChargerConfigurationFiltered(filtered);
            setConfigurationLoaded(true);
            setConfigurationLoadSuccess(true);
        } else if (chargerConfiguration?.error != null) {
            setConfigurationLoadSuccess(false);
        }
    }, [chargerConfiguration]);

    useEffect(() => {
        if (changeConfiguration.executed) {
            if (changeConfiguration.value) {
                const resultMap: Record<string, string | null> = {};
                configUpdateRequest.forEach((key, idx) => {
                    resultMap[key] = changeConfiguration.value?.[idx]?.val ?? null;
                });
                setConfigUpdateResponse(resultMap);

                const hasOnlyAccepted = Object.values(resultMap).every(val => val === 'Accepted');
                createAlertMessage(hasOnlyAccepted ? ocppCommunicationSuccess : ocppCommunicationFailed);
            }

            if (changeConfiguration.error) {
                dispatch(promiseError(changeConfiguration.error));
            }

            dispatch({ type: 'RESET_CHANGE_CONFIGURATION_STATE' });
        }
    }, [changeConfiguration, configUpdateRequest, createAlertMessage, dispatch]);

    useEffect(() => {
        if (resetChargerState.executed) {
            setConfirmDialogOpen({ ...confirmDialogOpen, reset: false })

            if (resetChargerState.value !== null) {
                createAlertMessage(resetChargerState.value)
            }
            if (resetChargerState.error && resetChargerState.executed) {
                dispatch(promiseError(resetChargerState.error))
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, resetChargerState)

    useEffect(() => {
        if (connectorAvailabilityState.executed && confirmDialogProps) {
            setConfirmDialogOpen({ ...confirmDialogOpen, avail: false })
            if (connectorAvailabilityState.value !== null) {
                if (
                    connectorAvailabilityState.value === ocppCommunicationSuccess ||
                    connectorAvailabilityState.value === ocppCommunicationFailedForcedSuccess
                ) {
                    const { connectorId, availType } = confirmDialogProps
                    dispatch(updateConnectorAvailability(initialModel.id, connectorId, availType))
                }
                createAlertMessage(connectorAvailabilityState.value)
            }
            if (connectorAvailabilityState.error) {
                dispatch(promiseError(connectorAvailabilityState.error))
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connectorAvailabilityState])

    useEffect(() => {
        if (unlockConnectorState.executed) {
            setConfirmDialogOpen({ ...confirmDialogOpen, unlock: false })
            if (unlockConnectorState.value !== null) {
                createAlertMessage(unlockConnectorState.value)
            }
            if (unlockConnectorState.error) {
                dispatch(promiseError(unlockConnectorState.error))
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [unlockConnectorState])

    useEffect(() => {
        if (uploadChargerCsvState.executed) {
            if (uploadChargerCsvState.value !== null) {
                createAlertMessage(uploadChargerCsvState.value)
            }
            if (uploadChargerCsvState.error) {
                dispatch(promiseError(uploadChargerCsvState.error))
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uploadChargerCsvState])

    useEffect(() => {
        if (stopChargingState.executed) {
            if (stopChargingState.value !== null && stopChargingState.value.state === ChargingSessionState.Parking) {
                createAlertMessage(0)
            }
            if (stopChargingState.error) {
                dispatch(promiseError(stopChargingState.error))
            }
        }
    }, [dispatch, stopChargingState])

    useEffect(() => {
        if (startChargingState.executed) {
            if (
                startChargingState.value !== null &&
                startChargingState.value.state === ChargingSessionState.InProgress &&
                !startChargingState.error
            ) {
                // reset authorization rfid on charge, so the authorized session will dissapear
                setChargerAuthorization('')
                createAlertMessage(0)
            }
            if (startChargingState.error) {
                dispatch(promiseError(startChargingState.error))
            }
        }
    }, [dispatch, startChargingState])

    useEffect(() => {
        dispatch(resetStartChargingState())
        dispatch(resetStoptChargingState())
        dispatch(resetChargerConfigurationState())
        setCustomConfigs([]);               // clear custom inputs
        setConfigUpdateRequest([]);         // clear submitted keys
        setConfigUpdateResponse({});        // clear tooltip statuses
        setChargerChangeConfiguration([]);  // optional: reset user edits on default configs
        setChargerConfigurationFiltered([]);
        setConfigurationLoaded(false);
        setConfigurationLoadSuccess(false);
    }, [dispatch, open])

    return (
        <>
            <Dialog className={classes.dialog} open={open}>
                <DialogTitle>{t('locations.chargerSettings')}</DialogTitle>
                <DialogContent>
                    <Tabs value={tabIndex} onChange={(event: any, newValue: number) => setTabIndex(newValue)}>
                        <Tab label={t('locations.basic')} color="primary" />
                        <Tab label="Configuration" />
                    </Tabs>
                    <TabPanel value={tabIndex} index={0} padding={0}>
                        {/* <Typography variant="subtitle1">{t('locations.resetCharger')}</Typography>
                        <Divider className={classes.dividerMarginBottom} /> */}
                        <Grid container alignItems="center" className={classes.spacedButtons}>
                            <Grid item xs={12} className={classes.centerButtons}>
                                <Button
                                    color="secondary"
                                    size="small"
                                    variant="contained"
                                    onClick={(ev) => {
                                        ev.preventDefault()
                                        handleChargerReset(1)
                                    }}
                                >
                                    {t('locations.softwareReset')}
                                </Button>
                                <Button
                                    color="secondary"
                                    size="small"
                                    variant="contained"
                                    onClick={(ev) => {
                                        ev.preventDefault()
                                        handleChargerReset(0)
                                    }}
                                >
                                    {t('locations.hardwareReset')}
                                </Button>
                            </Grid>
                        </Grid>
                        {chargerAuthorization
                            ? (() => {
                                const authorizedSession = getAuthorizedSessionInfo(chargerAuthorization)
                                const preparedConnector = getPreparedConnector()
                                return authorizedSession && preparedConnector ? (
                                    <>
                                        <Typography variant="subtitle1">Authorized session</Typography>
                                        <Divider className={classes.dividerMarginBottom} />
                                        <Grid container alignItems="center" className={classes.spacedButtons}>
                                            <Grid item xs={12}>
                                                <Table size="small">
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell>
                                                                <span className={classes.connectorId}>
                                                                    ID: {preparedConnector.externalId}
                                                                </span>
                                                            </TableCell>
                                                            <TableCell>
                                                                <span className={classes.connectorType}>
                                                                    {connectorToString(preparedConnector)}
                                                                </span>
                                                            </TableCell>
                                                            <TableCell>RFID: {chargerAuthorization}</TableCell>
                                                            <TableCell>
                                                                {moment(authorizedSession.startedAt).format('LLL')}
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                <Button
                                                                    variant="contained"
                                                                    size="small"
                                                                    color="secondary"
                                                                    onClick={(ev: SyntheticEvent) => {
                                                                        ev.preventDefault()
                                                                        handleStartTransaction(authorizedSession)
                                                                    }}
                                                                >
                                                                    Start
                                                                </Button>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </Grid>
                                        </Grid>
                                    </>
                                ) : null
                            })()
                            : null}

                        <Typography variant="subtitle1">{t('locations.connectors')}</Typography>
                        <Divider className={classes.dividerMarginBottom} />
                        <Grid container alignItems="center" className={classes.spacedButtons}>
                            <Grid item xs={12} className={classes.centerButtons}>
                                <Table size="small">
                                    <TableBody>
                                        {chargerConnectors && chargerConnectors.length ? (
                                            chargerConnectors.map((connector: ChargerConnector) => (
                                                <TableRow key={connector.id}>
                                                    <TableCell>
                                                        <span
                                                            className={`${getConnectorStatusClass(connector)} ${classes.connectorStatus
                                                                }`}
                                                        />
                                                        {connector.ocppStatus}
                                                    </TableCell>
                                                    <TableCell>
                                                        <span className={classes.connectorId}>
                                                            ID: {connector.externalId}
                                                        </span>
                                                    </TableCell>
                                                    <TableCell>
                                                        <span className={classes.connectorType}>
                                                            {connectorToString(connector)}
                                                        </span>
                                                    </TableCell>

                                                    <TableCell>
                                                        {(() => {
                                                            const currentSession = getCurrentSessionForConnector(connector);

                                                            // 1. Logika pre prebiehajúce session (bezo zmeny)
                                                            if (currentSession && currentSession.state === ChargingSessionState.Pending) {
                                                                return (
                                                                    <div>
                                                                        Session is Scheduled
                                                                        <Button
                                                                            variant="contained"
                                                                            size="small"
                                                                            color="secondary"
                                                                            onClick={(ev: SyntheticEvent) => {
                                                                                ev.preventDefault();
                                                                                handleStartTransaction(currentSession);
                                                                            }}
                                                                        >
                                                                            Start
                                                                        </Button>
                                                                    </div>
                                                                );
                                                            }

                                                            if (currentSession && currentSession.state === ChargingSessionState.InProgress) {
                                                                return (
                                                                    <div>
                                                                        Session in Progress
                                                                        <Button
                                                                            variant="contained"
                                                                            size="small"
                                                                            color="secondary"
                                                                            onClick={(ev: SyntheticEvent) => {
                                                                                ev.preventDefault();
                                                                                handleStopTransaction(currentSession.id);
                                                                            }}
                                                                        >
                                                                            Stop
                                                                        </Button>
                                                                    </div>
                                                                );
                                                            }

                                                            // 2. NOVÁ LOGIKA pre "Vehicle connected" (Preparing)
                                                            // Vyhadzujeme podmienku na state === Free, pretože Preparing je teraz Busy
                                                            if (connector.ocppStatus === 'Preparing') {
                                                                return (
                                                                    <div>
                                                                        Vehicle connected
                                                                        <Button
                                                                            variant="contained"
                                                                            size="small"
                                                                            color="secondary"
                                                                            onClick={(ev: SyntheticEvent) => {
                                                                                ev.preventDefault();
                                                                                openStartTransactionDialog();
                                                                            }}
                                                                        >
                                                                            Start
                                                                        </Button>
                                                                        <StartTransactionDialog
                                                                            open={transactionDetailsDialogOpen}
                                                                            onClose={handleStartTransactionDialogClose}
                                                                            connectorId={connector.id}
                                                                        />
                                                                    </div>
                                                                );
                                                            }

                                                            // 3. Fallback
                                                            return <div>No active session</div>;
                                                        })()}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <div className={classes.connectorButtons}>
                                                            <Button
                                                                variant="contained"
                                                                color="secondary"
                                                                size="small"
                                                                key={`availconnector.id`}
                                                                onClick={(ev: SyntheticEvent) => {
                                                                    ev.preventDefault()
                                                                    handleConnectorAvailability(
                                                                        connector.id,
                                                                        connector.availability ? 0 : 1
                                                                    )
                                                                }}
                                                            >
                                                                {connector.availability
                                                                    ? t('locations.enable')
                                                                    : t('locations.disable')}
                                                            </Button>

                                                            <Button
                                                                variant="contained"
                                                                size="small"
                                                                color="secondary"
                                                                onClick={(ev: SyntheticEvent) => {
                                                                    ev.preventDefault()
                                                                    handleConnectorUnlock(connector.id)
                                                                }}
                                                                key={`unlockconnector.id`}
                                                            >
                                                                {t('common.unlock')}
                                                            </Button>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell align="center">
                                                    <Typography>{t('locations.noConnectorsToList')}</Typography>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </Grid>
                        </Grid>
                        <Typography variant="subtitle1">{t('locations.sendRfidList')}</Typography>
                        <Divider className={classes.dividerMarginBottom} />
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} className={`${classes.spacedButtons} ${classes.centerButtons}`}>
                                <input
                                    accept=".csv,.txt"
                                    className={classes.uploadInput}
                                    id="inputUploadNew"
                                    onChange={handleFileUpload}
                                    onClick={() => setApiResponseMessage(defaultAlert)}
                                    type="file"
                                />
                                <label htmlFor="inputUploadNew">
                                    <Button
                                        color="secondary"
                                        variant="contained"
                                        component="span"
                                        size="small"
                                        onClick={(ev: SyntheticEvent) => ev.stopPropagation()}
                                        startIcon={<CloudUploadIcon />}
                                    >
                                        {t('locations.sendRfidListNew')}
                                    </Button>
                                </label>
                                <input
                                    accept=".csv,.txt"
                                    className={classes.uploadInput}
                                    id="inputUploadUpdate"
                                    onChange={handleFileUpload}
                                    onClick={() => setApiResponseMessage(defaultAlert)}
                                    type="file"
                                />
                                <label htmlFor="inputUploadUpdate">
                                    <Button
                                        color="secondary"
                                        variant="contained"
                                        component="span"
                                        size="small"
                                        onClick={(ev: SyntheticEvent) => ev.stopPropagation()}
                                        startIcon={<CloudUploadIcon />}
                                    >
                                        {t('locations.sendRfidListUpdate')}
                                    </Button>
                                </label>
                            </Grid>
                        </Grid>
                    </TabPanel>
                    <TabPanel value={tabIndex} index={1} padding={0}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} className={`${classes.spacedButtons} ${classes.centerButtons}`}>
                                <Button
                                    color="secondary"
                                    size="small"
                                    variant="contained"
                                    onClick={(ev) => {
                                        ev.preventDefault()
                                        handleGetConfiguration(externalId)
                                    }}
                                >
                                    {t('locations.getConfigurationStart')}
                                </Button>
                                <Button
                                    color="primary"
                                    size="small"
                                    variant="outlined"
                                    onClick={handleAddCustomConfig}
                                >
                                    + Add Custom Config
                                </Button>
                            </Grid>
                            {configurationLoaded && configurationLoadSuccess && chargerConfigurationFiltered && (
                                <Box mt={2} width={'100%'}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Key</TableCell>
                                                <TableCell>Value</TableCell>
                                                <TableCell align="center">Readonly</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {chargerConfigurationFiltered.map((entry: any) => (
                                                <TableRow key={entry.key}>
                                                    <TableCell>
                                                        <Box display="flex" alignItems="center">
                                                            {entry.key}
                                                            {configUpdateResponse[entry.key] && (
                                                                <Tooltip title={`Update status: ${configUpdateResponse[entry.key]}`} arrow>
                                                                    <InfoOutlined color={configUpdateResponse[entry.key] === 'Accepted' ? 'primary' : 'error'} fontSize="small" style={{ marginLeft: 4 }} />
                                                                </Tooltip>
                                                            )}
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        {entry.readonly ? (
                                                            <TextField
                                                                fullWidth
                                                                value={entry.value}
                                                                type="text"
                                                                variant="filled"
                                                                className={classes.input}
                                                                disabled
                                                            />
                                                        ) : (
                                                            renderConfigurationValueInput(entry)
                                                        )}
                                                    </TableCell>
                                                    <TableCell align="center">{entry.readonly ? 'Yes' : 'No'}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </Box>
                            )}
                            <Box mt={2} width={'100%'}>
                                <Table size="small">
                                    <TableBody>
                                        {customConfigs.map((config, index) => {
                                            const duplicate = isDuplicateKey(config.key, index);
                                            const updateStatus = configUpdateResponse[config.key];
                                            const showUpdateTooltip = !!updateStatus;
                                            const tooltipTitle = duplicate
                                                ? 'This key already exists in configuration.'
                                                : updateStatus
                                                    ? `Update status: ${updateStatus}`
                                                    : ''

                                            return (
                                                <TableRow key={`custom-${index}`}>
                                                    <TableCell className={classes.customKey}>
                                                        <Box display="flex" alignItems="center">
                                                            <TextField
                                                                className={classes.input}
                                                                fullWidth
                                                                value={config.key}
                                                                onChange={(e) => handleCustomConfigChange(index, 'key', e.target.value)}
                                                                variant="filled"
                                                                error={duplicate}
                                                            />
                                                            {(duplicate || showUpdateTooltip) && (
                                                                <Tooltip title={tooltipTitle} arrow>
                                                                    <InfoOutlined
                                                                        color={duplicate ? 'error' : updateStatus === 'Accepted' ? 'primary' : 'error'}
                                                                        fontSize="small"
                                                                        style={{ marginLeft: 4 }}
                                                                    />
                                                                </Tooltip>
                                                            )}
                                                        </Box>
                                                    </TableCell>

                                                    <TableCell className={classes.customValue}>
                                                        <TextField
                                                            className={classes.input}
                                                            fullWidth
                                                            value={config.value}
                                                            onChange={(e) => handleCustomConfigChange(index, 'value', e.target.value)}
                                                            variant="filled"
                                                        />
                                                    </TableCell>

                                                    <TableCell align="center">No</TableCell>

                                                    <TableCell align="right">
                                                        <IconButton onClick={() => handleRemoveCustomConfig(index)}>
                                                            <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </Box>

                            {configurationLoaded && !configurationLoadSuccess && (
                                <Typography color="error" className={classes.errorMessage}>
                                    Failed to load charger configuration.
                                </Typography>
                            )}
                        </Grid>
                    </TabPanel>
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    {tabIndex === 1 && (
                        <Grid>
                            <Button
                                color="secondary"
                                variant="contained"
                                onClick={(ev) => {
                                    ev.preventDefault()
                                    handleSetConfiguration()
                                }}
                            >
                                Change configuration
                            </Button>
                        </Grid>
                    )}
                    <Button
                        variant="contained"
                        onClick={() => {
                            setApiResponseMessage(defaultAlert)
                            onClose()
                        }}
                        color="primary"
                    >
                        {t('common.close')}
                    </Button>
                </DialogActions>
                {apiResponseMessage.message && (
                    <Snackbar
                        open={Boolean(apiResponseMessage.message)}
                        autoHideDuration={Boolean(apiResponseMessage.autohide) ? 1000 : undefined}
                    >
                        <Alert
                            onClose={() => setApiResponseMessage(defaultAlert)}
                            severity={apiResponseMessage.severity}
                        >
                            {apiResponseMessage.message}
                        </Alert>
                    </Snackbar>
                )}
            </Dialog>

            <ConfirmationDialog
                title={t('locations.resetTitle')}
                open={confirmDialogOpen.reset}
                content={t('locations.resetContent')}
                onCancel={() => setConfirmDialogOpen({ ...confirmDialogOpen, reset: false })}
                onConfirm={async () => {
                    const { resetType } = confirmDialogProps
                    await dispatch(resetCharger(initialModel, resetType))
                }}
                confirmLabel={t('common.reset')}
                cancelLabel={t('common.cancel')}
                inProgress={!resetChargerState.executed}
            />

            <ConfirmationDialog
                title={t('locations.changeAvailabilityTitle')}
                open={confirmDialogOpen.avail}
                content={t('locations.changeAvailabilityContent')}
                onCancel={() => {
                    setConfirmDialogOpen({ ...confirmDialogOpen, avail: false })
                }}
                onConfirm={async () => {
                    const { connectorId, availType } = confirmDialogProps
                    await dispatch(changeConnectorAvailability(connectorId, availType))
                }}
                confirmLabel={t('common.change')}
                cancelLabel={t('common.cancel')}
                inProgress={!connectorAvailabilityState.executed}
            />

            <ConfirmationDialog
                title={t('locations.unlockTitle')}
                open={confirmDialogOpen.unlock}
                content={t('locations.unlockContent')}
                onCancel={() => {
                    setConfirmDialogOpen({ ...confirmDialogOpen, unlock: false })
                }}
                onConfirm={async () => {
                    const { connectorId } = confirmDialogProps
                    await dispatch(unlockConnector(connectorId))
                }}
                confirmLabel={t('common.unlock')}
                cancelLabel={t('common.cancel')}
                inProgress={!unlockConnectorState.executed}
            />
        </>
    )
}

export default ChargerSettingsDialog
